import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Inventario',
    path: '/inventario/producto',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ProductoPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Productos</PageTitle>
      <View />
    </>
  );
};

export { ProductoPage };
